import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

export default {
  /* ── appraisals ── */
  list:           (params)   => api.get('/v1/appraisals', { params }).then(unwrap),
  get:            (id)       => api.get(`/v1/appraisals/${id}`).then(unwrap),
  create:         (body)     => api.post('/v1/appraisals', body).then(unwrap),
  update:         (id, body) => api.patch(`/v1/appraisals/${id}`, body).then(unwrap),
  addPhotos:      (id, photoUrls) => api.post(`/v1/appraisals/${id}/photos`, { photoUrls }).then(unwrap),
  saveChecks:     (id, body) => api.post(`/v1/appraisals/${id}/checks`, body).then(unwrap),
  submit:         (id)       => api.post(`/v1/appraisals/${id}/submit`).then(unwrap),
  setValuation:   (id, body) => api.post(`/v1/appraisals/${id}/valuation`, body).then(unwrap), // {tradeCents, retailCents}
  approve:        (id)       => api.post(`/v1/appraisals/${id}/approve`).then(unwrap),
  reject:         (id, reason) => api.post(`/v1/appraisals/${id}/reject`, { reason }).then(unwrap),
  convertToStock: (id)       => api.post(`/v1/appraisals/${id}/convert-to-stock`).then(unwrap),
  sendToTender:   (id, body) => api.post(`/v1/appraisals/${id}/tender`, body).then(unwrap), // {closesAt}

  /* ── tenders ── */
  tenders:     (params)   => api.get('/v1/tenders', { params }).then(unwrap),
  tender:      (id)       => api.get(`/v1/tenders/${id}`).then(unwrap),
  placeBid:    (id, body) => api.post(`/v1/tenders/${id}/bids`, body).then(unwrap),
  awardTender: (id, bidId) => api.post(`/v1/tenders/${id}/award`, { bidId }).then(unwrap),
  closeTender: (id)       => api.post(`/v1/tenders/${id}/close`).then(unwrap),
};
